import { AnonymousRecipient, PostUpList, Recipient, Station } from "../decoders/PostUp.types";
import axios, { AxiosRequestConfig } from "axios";
import { ILog } from "@ihr-radioedit/inferno-core";
import { environ } from "@ihr-radioedit/sdk-utils";
const log = ILog.logger("PostUp");

export const POSTUP_RECIPIENT_SOURCE = "newsletter";
export const POSTUP_RECIPIENT_CHANNEL = "E";

export interface PostupStationInterface {
  slug: string;
  lists: Station[];
}

interface PostUpQuery {
  base_uri: string;
  slug: string;
}

export const getStation = async ({ slug, base_uri }: PostUpQuery) => {
  log.debug("getStation", slug);
  try {
    const response = await axios.get<PostupStationInterface>(`${base_uri}/postup/station/${slug}/`, {
      timeout: parseInt(environ.get("REQUEST_TIMEOUT", "0"), 10),
    });
    return response.data;
  } catch (e) {
    log.debug(e.message);
    return {
      slug,
      lists: [],
    };
  }
};

interface PostUpGetRecipientQuery extends PostUpQuery {
  email?: string;
}

export const getRecipient = async ({ slug, base_uri, email }: PostUpGetRecipientQuery) => {
  log.debug("getRecipient", slug, email);
  try {
    const response = await axios.get<Recipient[]>(`${base_uri}/postup/recipient/${slug}/${email}/`, {
      timeout: parseInt(environ.get("REQUEST_TIMEOUT", "0"), 10),
    });
    return response.data;
  } catch (e) {
    log.debug(e.message);
    return [];
  }
};

interface PostUpGetSubscriptionsQuery extends PostUpQuery {
  recipientId: number;
}

export const getRecipientSubscriptions = async ({ slug, base_uri, recipientId }: PostUpGetSubscriptionsQuery) => {
  try {
    const response = await axios.get<PostUpList>(`${base_uri}/postup/subscription/${slug}/${recipientId}/`, {
      timeout: parseInt(environ.get("REQUEST_TIMEOUT", "0"), 10),
    });
    return response.data;
  } catch (e) {
    log.debug(e.message);
    return [];
  }
};

interface PostUpSendRecipientQuery extends PostUpQuery {
  recipient: AnonymousRecipient;
}

export const sendRecipient = async ({ slug, base_uri, recipient }: PostUpSendRecipientQuery) => {
  log.debug("sendRecipient", slug, recipient);
  try {
    const path = `${base_uri}/postup/recipient/${slug}/`;
    const config: AxiosRequestConfig = {
      timeout: parseInt(environ.get("REQUEST_TIMEOUT", "0"), 10),
    };
    const response = recipient.recipientId
      ? await axios.put<Recipient>(path, recipient, config)
      : await axios.post<Recipient>(path, recipient, config);
    return response.data;
  } catch (e) {
    log.debug(e.message);
    return {};
  }
};

interface PostUpSendSubscriptionListsQuery extends PostUpQuery {
  lists: PostUpList;
}

export const sendSubscriptionLists = async ({ slug, base_uri, lists }: PostUpSendSubscriptionListsQuery) => {
  log.debug("sendSubscriptionLists", slug, lists);
  try {
    const path = `${base_uri}/postup/updateListSubscriptions/${slug}/`;
    const response = await axios.put<PostUpList>(path, lists, {
      timeout: parseInt(environ.get("REQUEST_TIMEOUT", "0"), 10),
    });
    return response.data;
  } catch (e) {
    log.debug(e.message);
    return {};
  }
};
